// Nestaura Sliding Cart - SLOW ELEGANT VERSION with Enhanced Animations

class NestauraCart {
  constructor() {
    this.isOpen = false;
    this.items = [];
    this.isLoading = false;
    this.animationDuration = 800; // 0.8s to match CSS

    // 🎯 UPSELL PRODUCTS CONFIGURATION
    // Add your Shopify product handles and variant IDs here
    this.upsellProducts = {
      // Course upsells (shown when proteins in cart)
      courses: [
        {
          handle: "alpha-transformation-program", // Replace with your product handle
          variantId: "12345678901234", // Replace with your variant ID
          title: "Alpha Transformation Program",
          price: 237.6,
          originalPrice: 297.0,
          discount: 20,
          reason: "Maximize your results with expert guidance",
          image: "/cdn/shop/products/alpha-course.jpg", // Replace with your image
        },
        {
          handle: "strength-mastery-course",
          variantId: "12345678901235",
          title: "Strength Mastery Course",
          price: 157.6,
          originalPrice: 197.0,
          discount: 20,
          reason: "Master advanced strength techniques",
          image: "/cdn/shop/products/strength-course.jpg",
        },
      ],

      // Protein upsells (shown when courses in cart)
      proteins: [
        {
          handle: "alpha-whey-protein", // Replace with your product handle
          variantId: "12345678901236", // Replace with your variant ID
          title: "Alpha Whey Protein",
          price: 50.99,
          originalPrice: 59.99,
          discount: 15,
          reason: "Complete your transformation with premium supplements",
          image: "/cdn/shop/products/whey-protein.jpg", // Replace with your image
        },
        {
          handle: "alpha-mass-gainer",
          variantId: "12345678901237",
          title: "Alpha Mass Gainer",
          price: 67.99,
          originalPrice: 79.99,
          discount: 15,
          reason: "Fuel your muscle growth with high-quality calories",
          image: "/cdn/shop/products/mass-gainer.jpg",
        },
        {
          handle: "alpha-pre-workout",
          variantId: "12345678901238",
          title: "Alpha Pre-Workout",
          price: 42.49,
          originalPrice: 49.99,
          discount: 15,
          reason: "Boost your training intensity and focus",
          image: "/cdn/shop/products/pre-workout.jpg",
        },
      ],
    };

    // 🎁 GIFT PRODUCTS CONFIGURATION
    // Configure which gifts are given with which courses
    this.giftProducts = [
      {
        id: "gift-shaker",
        name: "Alpha Shaker Bottle",
        description: "Premium BPA-free shaker bottle with Nestaura branding",
        image: "/cdn/shop/products/shaker-bottle.jpg",
        eligibleForCourses: ["alpha-transformation-program"], // Product handles that get this gift
      },
      {
        id: "gift-ebook",
        name: "Alpha Mindset eBook",
        description: "Exclusive digital guide to developing an alpha mindset",
        image: "/cdn/shop/products/mindset-ebook.jpg",
        eligibleForCourses: [
          "alpha-transformation-program",
          "strength-mastery-course",
        ],
      },
      {
        id: "gift-workout-log",
        name: "Digital Workout Log",
        description: "Premium workout tracking application access",
        image: "/cdn/shop/products/workout-log.jpg",
        eligibleForCourses: ["strength-mastery-course"],
      },
    ];

    this.init();
  }

  init() {
    this.createCartHTML();
    this.bindEvents();
    this.loadCart();
    console.log("🚀 Nestaura Slow Elegant Cart initialized");
  }

  createCartHTML() {
    // Remove existing cart elements if present
    const existingBackdrop = document.getElementById("nestaura-cart-backdrop");
    const existingLeftOverlay = document.getElementById(
      "nestaura-cart-left-overlay",
    );
    const existingCart = document.getElementById("nestaura-sliding-cart");
    if (existingBackdrop) existingBackdrop.remove();
    if (existingLeftOverlay) existingLeftOverlay.remove();
    if (existingCart) existingCart.remove();

    // Create backdrop
    const backdrop = document.createElement("div");
    backdrop.id = "nestaura-cart-backdrop";
    backdrop.className = "nestaura-cart-backdrop";
    document.body.appendChild(backdrop);

    // Create left side overlay
    const leftOverlay = document.createElement("div");
    leftOverlay.id = "nestaura-cart-left-overlay";
    leftOverlay.className = "nestaura-cart-left-overlay";
    document.body.appendChild(leftOverlay);

    // Create sliding cart
    const cart = document.createElement("div");
    cart.id = "nestaura-sliding-cart";
    cart.className = "nestaura-sliding-cart";
    cart.innerHTML = `
      <div class="nestaura-cart-header">
        <div class="nestaura-cart-title">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
            <line x1="3" x2="21" y1="6" y2="6"/>
            <path d="M16 10a4 4 0 0 1-8 0"/>
          </svg>
          <h2>STACK</h2>
          <span class="nestaura-cart-badge-header" id="nestaura-cart-count">0</span>
        </div>
        <button class="nestaura-cart-close" id="nestaura-cart-close">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>
      <div class="nestaura-cart-content" id="nestaura-cart-content">
        <!-- Cart content will be populated here -->
      </div>
    `;

    document.body.appendChild(cart);
  }

  bindEvents() {
    // Cart icon clicks (multiple possible selectors)
    const cartSelectors = [
      'a[href="/cart"]',
      ".nestaura-cart-icon",
      ".cart-icon",
      ".header__icon--cart",
      '[data-action="open-cart"]',
    ];

    cartSelectors.forEach((selector) => {
      document.addEventListener("click", (e) => {
        if (e.target.closest(selector)) {
          e.preventDefault();
          this.openCart();
        }
      });
    });

    // Close cart events
    document.addEventListener("click", (e) => {
      if (
        e.target.id === "nestaura-cart-backdrop" ||
        e.target.id === "nestaura-cart-left-overlay" ||
        e.target.id === "nestaura-cart-close" ||
        e.target.closest("#nestaura-cart-close")
      ) {
        this.closeCart();
      }
    });

    // Escape key to close
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && this.isOpen) {
        this.closeCart();
      }
    });

    // Quantity and remove buttons (delegated)
    document.addEventListener("click", (e) => {
      if (e.target.closest(".nestaura-quantity-btn")) {
        const btn = e.target.closest(".nestaura-quantity-btn");
        const key = btn.dataset.key;
        const action = btn.dataset.action;

        if (key && action) {
          this.updateQuantity(key, action);
        }
      }

      if (e.target.closest(".nestaura-remove-btn")) {
        const btn = e.target.closest(".nestaura-remove-btn");
        const key = btn.dataset.key;
        if (key) {
          this.removeItem(key);
        }
      }

      if (e.target.closest(".nestaura-upsell-add-btn")) {
        const btn = e.target.closest(".nestaura-upsell-add-btn");
        const variantId = btn.dataset.variantId;
        if (variantId) {
          this.addUpsellToCart(variantId);
        }
      }

      if (e.target.closest(".nestaura-checkout-btn")) {
        this.proceedToCheckout();
      }
    });

    // Update cart when Shopify cart changes
    document.addEventListener("cart:updated", () => {
      this.loadCart();
    });
  }

  async loadCart() {
    try {
      const response = await fetch("/cart.js");
      const cart = await response.json();
      this.items = cart.items || [];
      this.updateCartDisplay();
      this.updateCartCount();
      console.log("🔄 Cart loaded:", this.items.length, "items");
    } catch (error) {
      console.error("❌ Failed to load cart:", error);
    }
  }

  updateCartCount() {
    const totalItems = this.items.reduce((sum, item) => sum + item.quantity, 0);

    // Update main cart badge
    const countElement = document.getElementById("nestaura-cart-count");
    if (countElement) {
      countElement.textContent = totalItems;
    }

    // Update any cart count badges in header
    const cartBadges = document.querySelectorAll(
      ".cart-count-bubble, .cart-badge, [data-cart-count]",
    );
    cartBadges.forEach((badge) => {
      badge.textContent = totalItems;
      badge.style.display = totalItems > 0 ? "flex" : "none";
    });
  }

  updateCartDisplay() {
    const contentElement = document.getElementById("nestaura-cart-content");
    if (!contentElement) return;

    if (this.items.length === 0) {
      contentElement.innerHTML = this.getEmptyCartHTML();
      return;
    }

    // Check what types of products are in cart for upsell logic
    const coursesInCart = this.items.some((item) =>
      this.isProductType(item, "course"),
    );
    const proteinsInCart = this.items.some((item) =>
      this.isProductType(item, "protein"),
    );

    contentElement.innerHTML = `
      <div class="nestaura-cart-items">
        ${this.items.map((item) => this.getCartItemHTML(item)).join("")}
      </div>
      ${this.getGiftsHTML()}
      ${this.getUpsellsHTML(coursesInCart, proteinsInCart)}
      <div class="nestaura-cart-summary">
        ${this.getCartSummaryHTML()}
      </div>
    `;

    // Apply staggered animations to items
    const items = contentElement.querySelectorAll(".nestaura-cart-item");
    items.forEach((item, index) => {
      item.style.animationDelay = `${0.3 + index * 0.1}s`;
    });

    // Remove supplement tags after DOM update
    this.removeSupplementTags();
  }

  removeSupplementTags() {
    // Wait a bit for DOM to fully render
    setTimeout(() => {
      // Remove all elements containing "supplement" text
      const elementsToRemove = document.querySelectorAll("*");
      elementsToRemove.forEach((el) => {
        if (
          el.textContent &&
          (el.textContent.toLowerCase().includes("supplement") ||
            el.textContent.includes("SUPPLEMENT")) &&
          !el.classList.contains("nestaura-cart-badge") &&
          !el.classList.contains("nestaura-trust-badges")
        ) {
          el.style.display = "none";
          el.remove();
        }
      });

      // Remove orange badges/tags by color and position
      const cart = document.getElementById("nestaura-sliding-cart");
      if (cart) {
        const suspiciousElements = cart.querySelectorAll("*");
        suspiciousElements.forEach((el) => {
          const style = window.getComputedStyle(el);
          if (
            (style.position === "absolute" &&
              style.backgroundColor.includes("255, 102, 0")) || // Orange color
            (el.style &&
              el.style.backgroundColor &&
              el.style.backgroundColor.includes("orange"))
          ) {
            el.style.display = "none";
            el.remove();
          }
        });
      }
    }, 100);
  }

  isProductType(item, type) {
    // Enhanced product type detection
    const handle = item.handle || item.product_handle || "";
    const productType = item.product_type || "";
    const vendor = item.vendor || "";
    const tags = item.properties?.tags || item.tags || "";

    if (type === "course") {
      return (
        handle.includes("course") ||
        handle.includes("program") ||
        handle.includes("training") ||
        productType.toLowerCase().includes("course") ||
        productType.toLowerCase().includes("program") ||
        tags.includes("course") ||
        tags.includes("digital")
      );
    }

    if (type === "protein") {
      return (
        handle.includes("protein") ||
        handle.includes("supplement") ||
        handle.includes("whey") ||
        handle.includes("mass") ||
        handle.includes("pre-workout") ||
        productType.toLowerCase().includes("supplement") ||
        productType.toLowerCase().includes("protein") ||
        tags.includes("supplement") ||
        tags.includes("protein")
      );
    }

    return false;
  }

  getEmptyCartHTML() {
    return `
      <div class="nestaura-cart-empty">
        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
          <line x1="3" x2="21" y1="6" y2="6"/>
          <path d="M16 10a4 4 0 0 1-8 0"/>
        </svg>
        <h3>EMPTY STACK</h3>
        <p>Build your performance stack</p>
        <button class="nestaura-checkout-btn" onclick="nestauraCart.closeCart()">
          SHOP
        </button>
      </div>
    `;
  }

  getCartItemHTML(item) {
    const isShippingFree = this.isProductType(item, "protein");
    const isCourse = this.isProductType(item, "course");

    return `
      <div class="nestaura-cart-item">
        <div class="nestaura-cart-item-content">
          <div class="nestaura-cart-item-image">
            <img src="${item.featured_image?.url || item.image || "/cdn/shop/products/placeholder.jpg"}"
                 alt="${item.product_title || item.title}"
                 loading="lazy">
          </div>
          <div class="nestaura-cart-item-info">
            <h4 class="nestaura-cart-item-name">${item.product_title || item.title}</h4>
            <p class="nestaura-cart-item-description">${item.product_description || item.variant_title || ""}</p>
            <div class="nestaura-cart-item-badges">
              <div class="nestaura-shipping-info ${isCourse ? "digital" : "free-shipping"}">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  ${
                    isCourse
                      ? '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7,10 12,15 17,10"/><line x1="12" x2="12" y1="15" y2="3"/>'
                      : '<path d="M14 18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>'
                  }
                </svg>
                ${isCourse ? "Instant Download" : "Free Shipping"}
              </div>
            </div>
          </div>
        </div>
        <div class="nestaura-cart-item-controls">
          <div class="nestaura-quantity-controls">
            <button class="nestaura-quantity-btn" data-key="${item.key}" data-action="decrease">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" x2="19" y1="12" y2="12"/>
              </svg>
            </button>
            <span class="nestaura-quantity-value">${item.quantity}</span>
            <button class="nestaura-quantity-btn" data-key="${item.key}" data-action="increase">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="12" x2="12" y1="5" y2="19"/>
                <line x1="5" x2="19" y1="12" y2="12"/>
              </svg>
            </button>
          </div>
          <div class="nestaura-cart-item-price-info">
            <div class="nestaura-cart-item-price">
              <div class="nestaura-cart-item-total">$${(item.final_line_price / 100).toFixed(2)}</div>
              ${item.quantity > 1 ? `<div class="nestaura-cart-item-unit">$${(item.price / 100).toFixed(2)} each</div>` : ""}
            </div>
            <button class="nestaura-remove-btn" data-key="${item.key}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 6h18"/>
                <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/>
                <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;
  }

  getGiftsHTML() {
    // Get eligible gifts based on courses in cart
    const courseHandles = this.items
      .filter((item) => this.isProductType(item, "course"))
      .map((item) => item.handle || item.product_handle || "");

    const eligibleGifts = this.giftProducts.filter((gift) =>
      gift.eligibleForCourses.some((courseHandle) =>
        courseHandles.includes(courseHandle),
      ),
    );

    if (eligibleGifts.length === 0) return "";

    let html = `
      <div class="nestaura-separator"></div>
      <div class="nestaura-gift-section">
        <div class="nestaura-gift-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="8" width="18" height="4" rx="1"/>
            <path d="M12 8v13"/>
            <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/>
            <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.9 4.9 0 0 1 12 8a4.9 4.9 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/>
          </svg>
          <h3>BONUS GEAR</h3>
        </div>
    `;

    eligibleGifts.forEach((gift) => {
      html += `
        <div class="nestaura-gift-item">
          <div class="nestaura-gift-content">
            <div class="nestaura-gift-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="8" width="18" height="4" rx="1"/>
                <path d="M12 8v13"/>
                <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"/>
                <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.9 4.9 0 0 1 12 8a4.9 4.9 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"/>
              </svg>
            </div>
            <div class="nestaura-gift-info">
              <div class="nestaura-gift-details">
                <h4>${gift.name}</h4>
                <p>${gift.description}</p>
              </div>
              <span class="nestaura-free-badge">FREE</span>
            </div>
          </div>
        </div>
      `;
    });

    html += "</div>";
    return html;
  }

  getUpsellsHTML(coursesInCart, proteinsInCart) {
    let upsells = [];

    // Show protein upsells if only courses in cart
    if (coursesInCart && !proteinsInCart) {
      upsells = [...this.upsellProducts.proteins];
    }

    // Show course upsells if only proteins in cart
    if (proteinsInCart && !coursesInCart) {
      upsells = [...this.upsellProducts.courses];
    }

    // Limit to 2 upsells for better UX
    upsells = upsells.slice(0, 2);

    if (upsells.length === 0) return "";

    let html = `
      <div class="nestaura-separator"></div>
      <div class="nestaura-upsell-section">
        <div class="nestaura-upsell-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22,12 18,12 15,21 9,3 6,12 2,12"/>
          </svg>
          <h3>LEVEL UP</h3>
        </div>
    `;

    upsells.forEach((upsell) => {
      html += `
        <div class="nestaura-upsell-item">
          <div class="nestaura-upsell-content">
            <div class="nestaura-upsell-image">
              <img src="${upsell.image}" alt="${upsell.title}" loading="lazy">
            </div>
            <div class="nestaura-upsell-info">
              <div class="nestaura-upsell-header-row">
                <h4 class="nestaura-upsell-name">${upsell.title}</h4>
                ${upsell.discount ? `<span class="nestaura-discount-badge">-${upsell.discount}%</span>` : ""}
              </div>
              <p class="nestaura-upsell-reason">${upsell.reason}</p>
              <div class="nestaura-upsell-footer">
                <div class="nestaura-upsell-pricing">
                  <span class="nestaura-upsell-price">$${upsell.price.toFixed(2)}</span>
                  ${upsell.originalPrice ? `<span class="nestaura-upsell-original">$${upsell.originalPrice.toFixed(2)}</span>` : ""}
                </div>
                <button class="nestaura-upsell-add-btn" data-variant-id="${upsell.variantId}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M5 12h14"/>
                    <path d="M12 5v14"/>
                  </svg>
                  +
                </button>
              </div>
            </div>
          </div>
        </div>
      `;
    });

    html += "</div>";
    return html;
  }

  getCartSummaryHTML() {
    const subtotal = this.items.reduce(
      (sum, item) => sum + item.final_line_price,
      0,
    );
    const shippingItems = this.items.filter((item) =>
      this.isProductType(item, "protein"),
    );
    const digitalItems = this.items.filter((item) =>
      this.isProductType(item, "course"),
    );
    const total = subtotal; // Free shipping, so total = subtotal

    return `
      <div class="nestaura-summary-row">
        <span class="nestaura-summary-label">Subtotal</span>
        <span class="nestaura-summary-value">$${(subtotal / 100).toFixed(2)}</span>
      </div>

      ${
        shippingItems.length > 0
          ? `
        <div class="nestaura-summary-row">
          <span class="nestaura-summary-label">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>
              <path d="M15 18h-2V6h2v12Z"/>
              <path d="M20 18V6a2 2 0 0 0-2-2h-2"/>
            </svg>
            Shipping
          </span>
          <span class="nestaura-summary-value free">FREE</span>
        </div>
      `
          : ""
      }

      ${
        digitalItems.length > 0
          ? `
        <div class="nestaura-summary-note">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7,10 12,15 17,10"/>
            <line x1="12" x2="12" y1="15" y2="3"/>
          </svg>
          ${digitalItems.length} digital ${digitalItems.length === 1 ? "course" : "courses"} • Instant access after purchase
        </div>
      `
          : ""
      }

      <div class="nestaura-summary-total">
        <span class="nestaura-summary-label">Total</span>
        <span class="nestaura-summary-value">$${(total / 100).toFixed(2)}</span>
      </div>

      <div class="nestaura-savings-note">
        🔥 You're saving on free shipping and exclusive alpha gifts!
      </div>

      <button class="nestaura-checkout-btn" ${this.isLoading ? "disabled" : ""}>
        ${
          this.isLoading
            ? '<div class="nestaura-loading"></div> PROCESSING'
            : `
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 12l2 2 4-4"/>
            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9s4.03-9 9-9c2.12 0 4.07.74 5.61 1.98"/>
          </svg>
          COMPLETE ORDER
        `
        }
      </button>

      <!-- Trust Badges -->
      <div class="nestaura-trust-badges">
        <div class="nestaura-trust-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <circle cx="12" cy="16" r="1"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
          <span>Secure Payment</span>
        </div>
        <div class="nestaura-trust-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/>
            <path d="M15 18h-2V6h2v12Z"/>
            <path d="M20 18V6a2 2 0 0 0-2-2h-2"/>
          </svg>
          <span>Free Shipping</span>
        </div>
        <div class="nestaura-trust-item">
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 12V8H6a2 2 0 0 1-2-2c0-1.1.9-2 2-2h12v4"/>
            <path d="M4 6v12c0 1.1.9 2 2 2h14v-4"/>
            <path d="M18 12a2 2 0 0 0-2 2c0 1.1.9 2 2 2h4v-4h-4z"/>
          </svg>
          <span>30-Day Guarantee</span>
        </div>
      </div>
    `;
  }

  async updateQuantity(key, action) {
    try {
      const item = this.items.find((item) => item.key === key);
      if (!item) return;

      const newQuantity =
        action === "increase" ? item.quantity + 1 : item.quantity - 1;

      if (newQuantity <= 0) {
        await this.removeItem(key);
        return;
      }

      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: key,
          quantity: newQuantity,
        }),
      });

      if (response.ok) {
        await this.loadCart();
        console.log(
          `📊 Updated quantity for ${item.product_title}: ${newQuantity}`,
        );
      }
    } catch (error) {
      console.error("❌ Failed to update quantity:", error);
    }
  }

  async removeItem(key) {
    try {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: key,
          quantity: 0,
        }),
      });

      if (response.ok) {
        await this.loadCart();
        console.log("🗑️ Item removed from cart");
      }
    } catch (error) {
      console.error("❌ Failed to remove item:", error);
    }
  }

  async addUpsellToCart(variantId) {
    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
        }),
      });

      if (response.ok) {
        await this.loadCart();
        console.log("✅ Upsell added to cart:", variantId);

        // Show success feedback
        const btn = document.querySelector(`[data-variant-id="${variantId}"]`);
        if (btn) {
          const originalText = btn.innerHTML;
          btn.innerHTML = "✅ Added!";
          btn.disabled = true;
          setTimeout(() => {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 2000);
        }
      }
    } catch (error) {
      console.error("❌ Failed to add upsell:", error);
    }
  }

  async proceedToCheckout() {
    if (this.isLoading || this.items.length === 0) return;

    try {
      this.isLoading = true;
      this.updateCartDisplay();

      // Add a slight delay for smooth UX
      await new Promise((resolve) => setTimeout(resolve, 500));

      // Redirect to Shopify checkout
      window.location.href = "/checkout";
    } catch (error) {
      console.error("❌ Checkout failed:", error);
      this.isLoading = false;
      this.updateCartDisplay();
    }
  }

  openCart() {
    this.isOpen = true;
    document.body.style.overflow = "hidden";

    const backdrop = document.getElementById("nestaura-cart-backdrop");
    const leftOverlay = document.getElementById("nestaura-cart-left-overlay");
    const cart = document.getElementById("nestaura-sliding-cart");

    if (backdrop) backdrop.classList.add("active");
    if (leftOverlay) leftOverlay.classList.add("active");
    if (cart) cart.classList.add("active");

    console.log("🛒 Cart opened elegantly with left overlay");
  }

  closeCart() {
    this.isOpen = false;

    const backdrop = document.getElementById("nestaura-cart-backdrop");
    const leftOverlay = document.getElementById("nestaura-cart-left-overlay");
    const cart = document.getElementById("nestaura-sliding-cart");

    if (backdrop) backdrop.classList.remove("active");
    if (leftOverlay) leftOverlay.classList.remove("active");
    if (cart) cart.classList.remove("active");

    // Restore body scroll after animation completes
    setTimeout(() => {
      document.body.style.overflow = "";
    }, this.animationDuration);

    console.log("❌ Cart closed elegantly with left overlay");
  }
}

// Initialize cart when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  window.nestauraCart = new NestauraCart();
});
